import { useState, useMemo } from 'react';
import { Input } from '../ui/input';

// 一覧用のキーワード検索＋絞り込み
// fields: 文字列キー or (item) => value の配列
// filters: [{ key, label, get?, dependsOn?, options: [{ value, label, parent? }] }]（dependsOnは親選択時のみ表示）
export function useFilteredList(items, fields = [], filters = []) {
  const [query, setQuery] = useState('');
  const [values, setValues] = useState({});

  const result = useMemo(() => {
    const q = query.trim().toLowerCase();
    return (items || []).filter(item => {
      for (const f of filters) {
        const selected = values[f.key] || 'all';
        if (selected === 'all') continue;
        const v = f.get ? f.get(item) : item[f.key];
        if (Array.isArray(v) ? !v.map(String).includes(selected) : String(v ?? '') !== selected) return false;
      }
      if (!q) return true;
      return fields.some(f => {
        const v = typeof f === 'function' ? f(item) : item[f];
        return String(v ?? '').toLowerCase().includes(q);
      });
    });
  }, [items, query, values]); // eslint-disable-line react-hooks/exhaustive-deps

  return { query, setQuery, values, setValues, filters, result };
}

export const ListToolbar = ({ filter, testId = 'list', placeholder = 'キーワード検索' }) => {
  const { query, setQuery, values, setValues, filters, result } = filter;
  return (
    <div className="flex flex-wrap items-center gap-2 mb-3" data-testid={`${testId}-toolbar`}>
      <Input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={placeholder}
        className="w-full sm:w-72 text-sm"
        data-testid={`${testId}-search`}
      />
      {filters.filter(f => !f.dependsOn || (values[f.dependsOn] && values[f.dependsOn] !== 'all')).map(f => (
        <select
          key={f.key}
          value={values[f.key] || 'all'}
          onChange={(e) => setValues(v => {
            const next = { ...v, [f.key]: e.target.value };
            filters.filter(c => c.dependsOn === f.key).forEach(c => { next[c.key] = 'all'; });
            return next;
          })}
          className="border rounded-md px-2 py-2 text-sm bg-white max-w-[260px]"
          data-testid={`${testId}-filter-${f.key}`}
        >
          <option value="all">{f.label}: すべて</option>
          {f.options.filter(o => !f.dependsOn || o.parent === values[f.dependsOn]).map(o => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      ))}
      {(query.trim() || Object.values(values).some(v => v && v !== 'all')) && (
        <span className="inline-flex items-center gap-2 whitespace-nowrap">
          <span className="text-xs text-gray-500" data-testid={`${testId}-result-count`}>{result.length}件が該当</span>
          <button
            type="button"
            className="text-xs text-[#00A651] hover:underline"
            data-testid={`${testId}-clear`}
            onClick={() => { setQuery(''); setValues({}); }}
          >
            条件をクリア
          </button>
        </span>
      )}
    </div>
  );
};

export default ListToolbar;
